/* eslint-disable default-case */
/* eslint-disable no-case-declarations */
/* eslint-disable require-jsdoc */

'use strict';

function toggleAllTabIndexes(containerSelector, tabindex) {
    if (!containerSelector) return;

    containerSelector
        .find(
            '.js-close-sub-menu, .js-close-custom-mobile-menu, .order-1 > ul > li > a, .order-2 > ul > li > a'
        )
        .attr('tabindex', tabindex);
    containerSelector.find('.js-close-sub-menu').focus();
}

function toggleTabIndexSubMenu(containerSelector, tabindex) {
    if (!containerSelector) return;

    containerSelector.find('ul li a').attr('tabindex', tabindex);
    containerSelector.find('ul li:first-child a').focus();
}

module.exports = {
    closeMobileMenu: function () {
        $('body').on('click', '.js-close-custom-mobile-menu', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $parent = $this.closest('.custom-mobile-menu');
            $('.sub-menu-mobile').removeClass('show');
            $('.new-sub-menu-mobile').removeClass('show');
            $('.js-open-sub-menu').removeClass('show');
            $('html, body').removeAttr('style');
            $('.js-custom-menu-trigger').attr('aria-expanded', 'false');
            $parent.removeClass('show');
        });
    },
    openMobileMenu: function () {
        $('body').on('click', '.js-custom-menu-trigger', function (e) {
            e.preventDefault();
            const isExpanded = $(this).attr('aria-expanded') === 'true';

            $(this).attr('aria-expanded', !isExpanded);
            if (!isExpanded) {
                $('.custom-mobile-menu').removeAttr('inert');
                // Focus on the menu after it slides in
                setTimeout(() => {
                    $('.custom-mobile-menu').focus();
                }, 300);
            }

            $('.custom-mobile-menu').addClass('show');
            $('html, body').css('overflow', 'hidden');
        });
    },
    openSubMenu: function () {
        $('body').on('click', '.js-open-sub-menu', function (e) {
            e.preventDefault();
            var $this = $(this);
            const isExpanded = $this.attr('aria-expanded') === 'true';
            var $catID = $this[0].id;
            var $parent = $this.closest('li');
            $(this).attr('aria-expanded', !isExpanded);
            $(this).attr('aria-hidden', 'false');
            if (!isExpanded) {
                $parent.find('.sub-menu-mobile#' + $catID).attr('tabindex', '0');
                $parent.find('.new-sub-menu-mobile#' + $catID).attr('tabindex', '0');
                toggleAllTabIndexes($parent.find('.sub-menu-mobile#' + $catID), 0);
                toggleTabIndexSubMenu(
                    $parent.find('.new-sub-menu-mobile#' + $catID),
                    0
                );
            } else {
                $parent.find('.sub-menu-mobile#' + $catID).attr('tabindex', '-1');
                $parent
                    .find('.new-sub-menu-mobile#' + $catID)
                    .attr('tabindex', '-1')
                    .attr('aria-hidden', 'true');
                toggleAllTabIndexes($parent.find('.sub-menu-mobile#' + $catID), -1);
                toggleTabIndexSubMenu(
                    $parent.find('.new-sub-menu-mobile#' + $catID),
                    -1
                );
            }
            $parent.find('.sub-menu-mobile#' + $catID).toggleClass('show');

            $this.toggleClass('show');
            $parent.find('.new-sub-menu-mobile#' + $catID).toggleClass('show');
        });
    },
    toggleCategoryMenu: function () {
        $('body').on('click', '.js-open-sub-new-menu', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $catID = $this[0].id;
            var $parent = $this.closest('li');
            $this.toggleClass('show');
            $parent.find('.new-sub-menu-mobile#' + $catID).toggleClass('show');
            $parent.find('.new-sub-menu-mobile#' + $catID).focus();
        });
    },
    closeSubMenu: function () {
        $('body').on('click', '.js-close-sub-menu', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $parent = $this.closest('.sub-menu-mobile');
            var $parentSubcat = $this.closest('.has-subcat');
            $parentSubcat.find('.js-open-sub-menu').attr('aria-expanded', 'false');
            $parentSubcat.find('.js-open-sub-menu').attr('aria-hidden', 'true');
            $parent.attr('tabindex', '-1');
            $parent.attr('aria-hidden', 'false');
            $parent
                .find('.new-sub-menu-mobile')
                .removeClass('show')
                .attr('tabindex', '-1');
            $parent.find('.new-sub-menu-mobile').attr('aria-hidden', 'false');
            toggleAllTabIndexes($parent, -1);
            toggleTabIndexSubMenu($parent.find('.new-sub-menu-mobile'), -1);
            $parent.removeClass('show');
            $('.custom-mobile-menu .menu .menu-top ul > li:first-child > a').focus();
        });
    },
    subMenuArrow: function () {
        document.addEventListener('DOMContentLoaded', function () {
            const menu = document.querySelector('ul[role="menu"]');
            const menuItems = menu.querySelectorAll('[role="menuitem"]');

            let currentIndex = 0;

            menu.addEventListener('keydown', function (event) {
                if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    currentIndex = (currentIndex + 1) % menuItems.length;
                    menuItems[currentIndex].focus();
                } else if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    currentIndex =
						(currentIndex - 1 + menuItems.length) % menuItems.length;
                    menuItems[currentIndex].focus();
                } else if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    menuItems[currentIndex].click();
                }
            });
        });
    },
};
